import {
  getCardsProductsList,
  type CardProduct,
} from 'api/v2/connectors/getCardsProductsList';
import { useQuery, type UseQueryResult } from 'react-query';
import { CardsProductsCacheKeys } from 'types/cacheKeys.types';

const useGetCardsProductsList = (): UseQueryResult<CardProduct[], unknown> => {
  return useQuery([CardsProductsCacheKeys.Cards], () => getCardsProductsList());
};

export default useGetCardsProductsList;
